import Dashboard from "./Dashboard";
import EPubTable from "./EPubTable";
import EPubForm from "./EPubForm";
import TopicTable from "./TopicTable";
import EditTopicForm from "./EditTopicForm";
import Footer from "./Footer";
import CSVUpload from './CSVUpload';
import AddGenusSpeciality from './AddGenusSpeciality';
import SubscriptionsTable from "./SubscriptionsTable";
import EditSubscriptionForm from './EditSubscriptionForm';
import UserTable from './UserTable';
import EditUserForm from './EditUserForm'

const compContents = [Dashboard, EPubTable, EPubForm, TopicTable, EditTopicForm, CSVUpload, AddGenusSpeciality,
    SubscriptionsTable, EditSubscriptionForm, EditUserForm, UserTable, Footer
]

export default compContents;